/* ===== App Root Component ===== */

import { RouterProvider } from 'react-router-dom'
import { AppContextProvider } from '@/presentation/providers/AppContextProvider'
import { ThemeProvider } from '@/presentation/providers/ThemeProvider'
import { OrganizationBrandProvider } from '@/presentation/providers/OrganizationBrandProvider'
import { router } from '@/app/router'

export default function App() {
  return (
    <ThemeProvider>
      <AppContextProvider>
        <OrganizationBrandProvider>
          <RouterProvider router={router} />
        </OrganizationBrandProvider>
      </AppContextProvider>
    </ThemeProvider>
  )
}
